// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 
  # product item
*/
.product_product-item__jEYbE {
  width: 48%;
  margin-bottom: 4px;
}
.product_product-image__O8ihT {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}
.product_image__oUp9q {
  display: flex;
}
.product_image__oUp9q img {
  min-width: 165px;
  min-height: 198px;
  background: #fff;
  border-radius: 4px;
}
.product_discount__mnUee {
  position: absolute;
  top: 8px;
  left: 8px;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  background: #101010;
  width: 35px;
  height: 20px;
  z-index: 200;
}
.product_discount__mnUee span {
  color: #fff;
  text-align: center;
  font-size: 11px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -1px;
  font-family: yekanbakh-fa;
}
.product_Remaining__aNlm8 {
  position: absolute;
  bottom: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 70%;
  padding: 1px 4px;
  /* height: 20px; */
  font-size: 9px;
  border-radius: 4px;
  background: linear-gradient(266deg, #ef6b26 0%, #ff1313 53.32%);
  color: #fff;
  font-weight: 600;
  line-height: 20px;
  margin: 0 30px;
  gap: 4px;
  z-index: 200;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.product_overlay__isGlY {
  background: rgba(111, 115, 119, 0.07);
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  border-radius: 4px;
}
.product_overlay-unavilable__6Pmy0 {
  background: #00000033;
  left: 0;
  top: 0;
  position: absolute;
  right: 0;
  bottom: 0;
}
.product_Remaining__aNlm8 span {
  font-family: yekanbakh-fa;
}
.product_unavailable__ZnOLM {
  position: absolute;
  bottom: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 70%;
  border-radius: 4px;
  background: #101010;
  gap: 4px;
  /* height: 20px; */
  padding: 1px 4px;
  z-index: 200;
}
.product_unavailable__ZnOLM span {
  color: #fff;
  text-align: right;
  font-size: 9px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
}
.product_unavailable__ZnOLM span img {
}
.product_product-info__to3qU {
  font-size: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 6px;
  margin-top: 4px;
}
.product_product-price__gGZbD {
  color: var(--productTextLow);
  text-align: right;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration: line-through;
  text-decoration-color: #7e84a66e;
}
.product_no-discount__4VI2X {
  text-decoration: unset;
  color: var(--productText);
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
}
.product_brand-name__1xDIq {
  color: var(--productText);
  text-align: right;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  font-family: poppins;
}
.product_specific-price__vtbQO {
  color: #F7FF65;
  text-align: right;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  display: flex;
  gap: 4px;
}
.product_specific-price__vtbQO img {
  padding-bottom: 2px;
}
.product_product-title__p4\\+tX {
  width: 167px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  color: var(--productText);
  text-align: right;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}
.product_product-buy__oI75I {
  background: blanchedalmond;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  margin-top: 12px;
  width: 100%;
}
.product_club__QBbvi {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 4px;
  margin-top: 7px;
  width: 100%;
  background: rgb(249 175 35 / 7%);
  padding: 2px 4px;
  border-radius: 6px;
}
.product_club__QBbvi img {
  width: 16px;
}
.product_club__QBbvi span {
  color: rgb(249, 175, 35);
  font-size: 11px;
}

@media screen and (min-width: 1200px) {
  .product_club__QBbvi span {
    font-size: 14px;
  }
  .product_club__QBbvi img {
    width: 20px;
  }
  .product_specific-price__vtbQO img {
    width: 20px;
    padding: unset;
  }
  .product_unavailable__ZnOLM span img {
    width: 16px;
  }
  .product_unavailable__ZnOLM span {
    font-size: 12px;
    font-style: normal;
    font-weight: 450;
    line-height: 20px;
  }
  .product_unavailable__ZnOLM {
    padding: 3px 4px;
    height: unset;
    width: fit-content;
  }
  .product_product-item__jEYbE {
    width: 23.9%;
  }
  .product_product-items__6FkAV {
    max-width: 1200px;
  }
  .product_product-inner__ipe\\+O {
    padding: 0 16px;
    width: 100%;
    max-width: 1200px;
  }

  .product_image__oUp9q img {
    min-width: 220px;
    min-height: 264px;
  }

  .product_Remaining__aNlm8 {
    width: fit-content;
    font-size: 12px;
    font-weight: 400;

    height: unset;
    padding: 3px 4px;
  }
  .product_Remaining__aNlm8 img {
    width: 16px;
  }
  .product_brand-name__1xDIq,
  .product_specific-price__vtbQO {
    font-size: 14px;
  }
  .product_product-title__p4\\+tX {
    font-size: 14px;
    width: 203px;
  }
  .product_product-price__gGZbD {
    font-size: 13px;
  }
  .product_discount__mnUee {
    width: unset;
    height: unset;
    padding: 2px 6px 0px 6px;
  }
  .product_discount__mnUee span {
    font-weight: 400;
    font-size: 14px;
  }
  .product_banner__gUfgz {
    margin: 80px 0;
  }
}
@media screen and (max-width: 400px) {
  .product_image__oUp9q img {
    min-width: unset;
    min-height: unset;
  }
  .product_product-title__p4\\+tX {
    width: 125px;
  }
}

@media screen and (max-width: 339px) {
  .product_image__oUp9q img {
    min-width: unset;
    min-height: unset;
  }
  .product_product-title__p4\\+tX {
    width: 100%;
  }
  .product_product-item__jEYbE {
    /* width: 46%; */
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/products/single/product.module.css"],"names":[],"mappings":"AAAA;;CAEC;AACD;EACE,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,YAAY;AACd;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,+DAA+D;EAC/D,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,QAAQ;EACR,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,QAAQ;EACR,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,OAAO;EACP,MAAM;EACN,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,kBAAkB;EAClB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;AACA;AACA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;EAC7B,gCAAgC;AAClC;AACA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,QAAQ;AACV;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,WAAW;EACX,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,cAAc;EAChB;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,aAAa;IACb,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;;IAEhB,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;;IAEE,eAAe;EACjB;EACA;IACE,eAAe;IACf,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;IACZ,aAAa;IACb,wBAAwB;EAC1B;EACA;IACE,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/* \n  # product item\n*/\n.product-item {\n  width: 48%;\n  margin-bottom: 4px;\n}\n.product-image {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.image {\n  display: flex;\n}\n.image img {\n  min-width: 165px;\n  min-height: 198px;\n  background: #fff;\n  border-radius: 4px;\n}\n.discount {\n  position: absolute;\n  top: 8px;\n  left: 8px;\n  color: #fff;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 10px;\n  background: #101010;\n  width: 35px;\n  height: 20px;\n  z-index: 200;\n}\n.discount span {\n  color: #fff;\n  text-align: center;\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: -1px;\n  font-family: yekanbakh-fa;\n}\n.Remaining {\n  position: absolute;\n  bottom: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 70%;\n  padding: 1px 4px;\n  /* height: 20px; */\n  font-size: 9px;\n  border-radius: 4px;\n  background: linear-gradient(266deg, #ef6b26 0%, #ff1313 53.32%);\n  color: #fff;\n  font-weight: 600;\n  line-height: 20px;\n  margin: 0 30px;\n  gap: 4px;\n  z-index: 200;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.overlay {\n  background: rgba(111, 115, 119, 0.07);\n  position: absolute;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  border-radius: 4px;\n}\n.overlay-unavilable {\n  background: #00000033;\n  left: 0;\n  top: 0;\n  position: absolute;\n  right: 0;\n  bottom: 0;\n}\n.Remaining span {\n  font-family: yekanbakh-fa;\n}\n.unavailable {\n  position: absolute;\n  bottom: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 70%;\n  border-radius: 4px;\n  background: #101010;\n  gap: 4px;\n  /* height: 20px; */\n  padding: 1px 4px;\n  z-index: 200;\n}\n.unavailable span {\n  color: #fff;\n  text-align: right;\n  font-size: 9px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n}\n.unavailable span img {\n}\n.product-info {\n  font-size: 12px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 6px;\n  margin-top: 4px;\n}\n.product-price {\n  color: var(--productTextLow);\n  text-align: right;\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  text-decoration: line-through;\n  text-decoration-color: #7e84a66e;\n}\n.no-discount {\n  text-decoration: unset;\n  color: var(--productText);\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 700;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 4px;\n}\n.brand-name {\n  color: var(--productText);\n  text-align: right;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  font-family: poppins;\n}\n.specific-price {\n  color: #F7FF65;\n  text-align: right;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n  display: flex;\n  gap: 4px;\n}\n.specific-price img {\n  padding-bottom: 2px;\n}\n.product-title {\n  width: 167px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  color: var(--productText);\n  text-align: right;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n}\n.product-buy {\n  background: blanchedalmond;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 12px;\n  margin-top: 12px;\n  width: 100%;\n}\n.club {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 4px;\n  margin-top: 7px;\n  width: 100%;\n  background: rgb(249 175 35 / 7%);\n  padding: 2px 4px;\n  border-radius: 6px;\n}\n.club img {\n  width: 16px;\n}\n.club span {\n  color: rgb(249, 175, 35);\n  font-size: 11px;\n}\n\n@media screen and (min-width: 1200px) {\n  .club span {\n    font-size: 14px;\n  }\n  .club img {\n    width: 20px;\n  }\n  .specific-price img {\n    width: 20px;\n    padding: unset;\n  }\n  .unavailable span img {\n    width: 16px;\n  }\n  .unavailable span {\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 450;\n    line-height: 20px;\n  }\n  .unavailable {\n    padding: 3px 4px;\n    height: unset;\n    width: fit-content;\n  }\n  .product-item {\n    width: 23.9%;\n  }\n  .product-items {\n    max-width: 1200px;\n  }\n  .product-inner {\n    padding: 0 16px;\n    width: 100%;\n    max-width: 1200px;\n  }\n\n  .image img {\n    min-width: 220px;\n    min-height: 264px;\n  }\n\n  .Remaining {\n    width: fit-content;\n    font-size: 12px;\n    font-weight: 400;\n\n    height: unset;\n    padding: 3px 4px;\n  }\n  .Remaining img {\n    width: 16px;\n  }\n  .brand-name,\n  .specific-price {\n    font-size: 14px;\n  }\n  .product-title {\n    font-size: 14px;\n    width: 203px;\n  }\n  .product-price {\n    font-size: 13px;\n  }\n  .discount {\n    width: unset;\n    height: unset;\n    padding: 2px 6px 0px 6px;\n  }\n  .discount span {\n    font-weight: 400;\n    font-size: 14px;\n  }\n  .banner {\n    margin: 80px 0;\n  }\n}\n@media screen and (max-width: 400px) {\n  .image img {\n    min-width: unset;\n    min-height: unset;\n  }\n  .product-title {\n    width: 125px;\n  }\n}\n\n@media screen and (max-width: 339px) {\n  .image img {\n    min-width: unset;\n    min-height: unset;\n  }\n  .product-title {\n    width: 100%;\n  }\n  .product-item {\n    /* width: 46%; */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"product-item": `product_product-item__jEYbE`,
	"product-image": `product_product-image__O8ihT`,
	"image": `product_image__oUp9q`,
	"discount": `product_discount__mnUee`,
	"Remaining": `product_Remaining__aNlm8`,
	"overlay": `product_overlay__isGlY`,
	"overlay-unavilable": `product_overlay-unavilable__6Pmy0`,
	"unavailable": `product_unavailable__ZnOLM`,
	"product-info": `product_product-info__to3qU`,
	"product-price": `product_product-price__gGZbD`,
	"no-discount": `product_no-discount__4VI2X`,
	"brand-name": `product_brand-name__1xDIq`,
	"specific-price": `product_specific-price__vtbQO`,
	"product-title": `product_product-title__p4+tX`,
	"product-buy": `product_product-buy__oI75I`,
	"club": `product_club__QBbvi`,
	"product-items": `product_product-items__6FkAV`,
	"product-inner": `product_product-inner__ipe+O`,
	"banner": `product_banner__gUfgz`
};
export default ___CSS_LOADER_EXPORT___;
